var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-placeholder"},[_c('img',{attrs:{"id":"preview-image","src":_vm.noPreviewImg,"alt":"no preview"}}),_c('h1',[_vm._v("No Resource Assigned")]),_c('h2',[_vm._v("This is a placeholder screen. Please, assign a resource to this task.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }